import script from "./billing-information-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./billing-information-settings.vue?vue&type=script&setup=true&lang=js"

import "./billing-information-settings.vue?vue&type=style&index=0&id=08ee8894&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ee8894"]])

export default __exports__